'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactCssThemr = require('react-css-themr');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactCssThemr.ThemeProvider;
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toolbox/lib/ThemeProvider.js
// module id = 203
// module chunks = 0